import React, { useState } from 'react';
import { PageLoaderLayer } from '../../../components/general/loading-state/loader-layers/page-loader-layer/page-loader-layer';
import { ChevronIcon, ListItemLayout, ListLayout, PageHeader } from '@keplerco/core';
import { RatingIcon } from '../../../design/icons/rating.icon';
import { GroupAssessmentIcon } from '../../../design/icons/group-assessment.icon';
import { QuestionnaireIcon } from '../../../design/icons/questionnaire.icon';
import { FOPIcon } from '../../../design/icons/fop.icon';
import { PagePath } from '../../../navigation/navigation.enums';
import { PaywallModal } from '../components/paywall/paywall-modal';

export function FreemiumCreateAssessmentPage(): JSX.Element {
  const [isPaywallModalOpen, setIsPaywallModalOpen] = useState(false);

  const handleFeatureClick = () => {
    setIsPaywallModalOpen(true);
  };

  return (
    <PageLoaderLayer path={PagePath.assessmentManagementCreate}>
      <div className="wrapper stack" style={{ paddingBottom: 30, gap: 30 }}>
        <PageHeader
          breadcrumbs={[]}
          title="Create assessment"
          subtitle="Select from Peer Assessment, Questionnaire-Based Assessment, or Fields of Practice Assessment to accurately evaluate skill levels"
          divider
        />

        <ListLayout gap={30}>
          <ListItemLayout>
            <div
              style={{ textDecoration: 'none', cursor: 'pointer' }}
              onClick={() => handleFeatureClick()}
              className="card action-card interactive"
            >
              <RatingIcon />

              <div className="action-card-content">
                <h3>Rating Assessment</h3>
                <p>Select subjects of an assessment, and the users to rate them on a list of chosen skills</p>
                <span style={{ color: 'var(--primary)', fontSize: '0.85rem', fontWeight: 'bold' }}>Premium Feature</span>
              </div>

              <ChevronIcon tone="primary" strokeWidth={1} size={40} />
            </div>
          </ListItemLayout>

          <ListItemLayout>
            <div
              style={{ textDecoration: 'none', cursor: 'pointer' }}
              onClick={() => handleFeatureClick()}
              className="card action-card interactive"
            >
              <GroupAssessmentIcon />

              <div className="action-card-content">
                <h3>Group Assessment</h3>
                <p>Allow a group of people to endorse each other's skills. Ideal for teams that share similar skill sets, and work in collaboration with one another.</p>
                <span style={{ color: 'var(--primary)', fontSize: '0.85rem', fontWeight: 'bold' }}>Premium Feature</span>
              </div>

              <ChevronIcon tone="primary" strokeWidth={1} size={40} />
            </div>
          </ListItemLayout>

          <ListItemLayout>
            <div
              style={{ textDecoration: 'none', cursor: 'pointer' }}
              onClick={() => handleFeatureClick()}
              className="card action-card interactive"
            >
              <QuestionnaireIcon />

              <div className="action-card-content">
                <h3>Questionnaire Based Assessment</h3>
                <p>Answer scenario based questions in a multiple choice format. Ideal for assessing behavioural competencies. Select from a list of assessment questionnaires focused on a variety of essential skill sets.</p>
                <span style={{ color: 'var(--primary)', fontSize: '0.85rem', fontWeight: 'bold' }}>Premium Feature</span>
              </div>

              <ChevronIcon tone="primary" strokeWidth={1} size={40} />
            </div>
          </ListItemLayout>

          <ListItemLayout>
            <div
              style={{ textDecoration: 'none', cursor: 'pointer' }}
              onClick={() => handleFeatureClick()}
              className="card action-card interactive"
            >
              <FOPIcon />

              <div className="action-card-content">
                <h3>Fields of Practice Assessment</h3>
                <p>Allows people to compare their skills against regulatory expectations. Ideal for assessments that align with regulatory requirements. Ask your customer success manager about adding assessments for new regulatory frameworks.</p>
                <span style={{ color: 'var(--primary)', fontSize: '0.85rem', fontWeight: 'bold' }}>Premium Feature</span>
              </div>

              <ChevronIcon tone="primary" strokeWidth={1} size={40} />
            </div>
          </ListItemLayout>
        </ListLayout>
      </div>

      {/* Paywall Modal */}
      <PaywallModal
        isOpen={isPaywallModalOpen}
        onClose={() => setIsPaywallModalOpen(false)}
      />
    </PageLoaderLayer>
  );
}
